/**
 * Opt-in granular tracing for CMRP (course materials) selection → API → render.
 *
 * In DevTools on the course materials page, before reproducing:
 *   window.CMRP_TRACE_FLOW = true
 * Then add a course or open a deep link; watch console for "[CMRP flow]" lines.
 *
 * Payload may be a plain object or a zero-arg function returning the object (evaluated
 * only when tracing is on — avoids TDZ / "before initialization" when logging locals).
 */
(function (w) {
  if (!w) return;

  /**
   * @param {unknown} s
   * @returns {{ len: number, amp: number, pct26: number, preview: string }}
   */
  function ampScan(s) {
    const str = s == null ? '' : String(s);
    return {
      len: str.length,
      amp: (str.match(/&/g) || []).length,
      pct26: (str.match(/%26/gi) || []).length,
      preview: str.length > 160 ? str.slice(0, 160) + '\u2026' : str,
    };
  }

  /**
   * @param {string} tag
   * @param {unknown | (() => unknown)} payloadOrFn
   */
  w.cmrpFlowTrace = function cmrpFlowTrace(tag, payloadOrFn) {
    if (!w.CMRP_TRACE_FLOW) return;
    try {
      const p =
        payloadOrFn === undefined
          ? {}
          : typeof payloadOrFn === 'function'
            ? payloadOrFn()
            : payloadOrFn;
      console.info('[CMRP flow]', tag, p === undefined ? {} : p);
    } catch (_e) {
      /* ignore */
    }
  };

  /**
   * @param {string} tag
   * @param {unknown | (() => unknown)} sOrFn
   */
  w.cmrpFlowTraceAmp = function cmrpFlowTraceAmp(tag, sOrFn) {
    if (!w.CMRP_TRACE_FLOW) return;
    try {
      const raw =
        typeof sOrFn === 'function' ? sOrFn() : sOrFn;
      console.info('[CMRP flow]', tag, ampScan(raw));
    } catch (_e) {
      /* ignore */
    }
  };
})(typeof window !== 'undefined' ? window : undefined);
